import { useTranslation } from 'react-i18next';

import TwoColumnL30R70 from '@klaviyo-mkt/gatsby-components/utils/two-column-l30-r70';
import GlobalHead from '../../components/head';
import TopicsMenuWithData from '../../components/topics-menu';
import ArchiveCard from '@klv/molecules/archive-card';
import Layout from '../../layout';

import { sites } from '../../constants';
import useFeaturedResources from '../../hooks/useHomeData';

import * as s from './styles';

import type { HeadProps, PageProps } from 'gatsby';
import type { TArchiveCardColors } from '@klaviyo-mkt/gatsby-components/molecules/archive-card/types';
import type { IPageContext } from '../../components/head/types';

const FeaturedResources = () => {
  const { t } = useTranslation();

  const { featuredResources } = useFeaturedResources();

  return (
    <s.FeaturedResources>
      <s.StyledFeaturedHeadline
        variant='h5Semibold'
        forwardedAs='h1'
      >
        {t('helpCenter_templates_home_featuredResources_headline')}
      </s.StyledFeaturedHeadline>
      <s.StyledFeaturedSubhead
        variant='h6'
        forwardedAs='h2'
      >
        {t('helpCenter_templates_home_featuredResources_subhead')}
      </s.StyledFeaturedSubhead>

      <s.ResourceCardList>
        {featuredResources?.map((post) => {
          const { backgroundColor, postTitle, excerpt, url, resource } = post;
          return (
          <ArchiveCard
            key={postTitle}
            backgroundColor={backgroundColor as TArchiveCardColors}
            resource={resource}
            postTitle={postTitle}
            excerpt={excerpt}
            url={url}
          /> 
          );
        })}
      </s.ResourceCardList>
    </s.FeaturedResources>
  );
};

const translations = sites.map(({ hreflang, locale, path }) => ({
  hreflang,
  locale,
  url: path,
}));

export const Home = ({ location, ...pageProps }: PageProps) => {
  const { t } = useTranslation();

  return (
    <Layout
      {...pageProps}
      location={location}
      translations={translations}
    >
      <s.StyledContainer>
        <TwoColumnL30R70 
          headline={t('helpCenter_templates_home_twoColumnL30R70_headline')}
          childrenLeft={<TopicsMenuWithData selectedTopic={t('helpCenter_components_topicsMenu_featuredResources_name')}/>}
          childrenRight={<FeaturedResources />}
        />
      </s.StyledContainer>
    </Layout>
  );
};

export const Head = ({ location, pageContext }: HeadProps<null, IPageContext>)  => (
  <GlobalHead
    langCode={pageContext?.locale}
    pathname={location.pathname}
    translations={translations}
  />
);
